module.exports = __webpack_public_path__ + "static/media/publication_newsletter_01_20201019.a6661cb6.png";